import React, { FC, MouseEventHandler, MouseEvent } from 'react';
import styles from './index.module.css';
import { ShareModalProps } from './types';
import { Button, Modal, Space, Input, Skeleton } from 'antd';
import { CloseModal } from 'appJS/components/CloseModal';
import * as translations from './strings';
import { getLangKey } from 'appJS/models/Language';
import { handleCopy } from 'appJS/utils/handleCopy';
import HelpArticleButton from 'appJS/utils/HelpArticleButton';

const strings = translations[getLangKey()];

export const ShareModal: FC<ShareModalProps> = ({
  shareURL,
  container,
  open,
  closeModal,
  canInviteToProject,
  inviteEndpoint
}) => {
  const isShareGroup = shareURL?.includes('share_group');
  const handleInviteButtonClick: MouseEventHandler<HTMLElement> = (
    event: MouseEvent<HTMLElement, globalThis.MouseEvent>
  ) => {
    event.stopPropagation();
    event.preventDefault();

    if (inviteEndpoint) {
      window.open(inviteEndpoint, '_self');
    } else {
      closeModal();
      window.share_project_props?.setShow?.(true);
    }
  };

  return (
    <Modal
      wrapClassName={styles.shareModal}
      open={open}
      getContainer={container}
      closeIcon={
        <CloseModal className={styles.closeModal} handleClick={closeModal} />
      }
      onCancel={closeModal}
      title={null}
      footer={null}
      centered
      destroyOnClose
    >
      <Skeleton
        loading={!shareURL}
        paragraph={{ rows: 3, width: ['100%', '100%', '70%'] }}
        active
      >
        <div className={styles.shareDeliverables}>
          <div className={styles.leftModal}>
            <h2 className={styles.shareModalHeader}>
              {isShareGroup ? strings.shareGroupHeader : strings.shareHeader}
            </h2>
            <p className={styles.shareUrlMessage}>{strings.shareUrlMessage}</p>
            <Space.Compact className={styles.inputGroup}>
              <Input
                className={styles.assetUrlInput}
                value={shareURL}
                readOnly
              />
              <Button
                className={styles.copyButton}
                onClick={() =>
                  handleCopy({
                    text: shareURL,
                    successMessage:
                      'The asset URL has been copied to your clipboard.'
                  })
                }
                type="primary"
              >
                {strings.copy}
              </Button>
            </Space.Compact>
            {canInviteToProject && (
              <Button
                type="link"
                href={inviteEndpoint}
                className={styles.inviteLink}
                onClick={handleInviteButtonClick}
              >
                {strings.inviteMessage}
              </Button>
            )}
          </div>

          <div className={styles.rightModal}>
            <HelpArticleButton articleId={11468112} />
            <h3>What's this like for my client?</h3>
            <iframe
              src="https://player.vimeo.com/video/1057731736?h=d37700eaf1&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              title="Watch this quick explainer (30 sec)"
            />
            <p className={styles.small}>Watch this quick explainer (30 sec)</p>
          </div>
        </div>
      </Skeleton>
    </Modal>
  );
};
